import React from 'react';
import { Outlet } from 'react-router-dom';

export function LegalLayout() {
  return <Outlet />
}

export default LegalLayout;
